import React from 'react';

// DO NOT EDIT - THIS FILE IS GENERATED
/* eslint-disable */

var curbsideIcon = /*#__PURE__*/React.createElement("svg", {
  height: "24",
  width: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M.652 7.742c1.83-.422 3.632.818 4.051 2.776l.012.06.082.41-.913.21-.082-.41C3.518 9.354 2.218 8.434.888 8.716l-.04.01-.153.034L.5 7.777l.152-.035Z",
  fill: "#D22030"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.097 11.563c-1.43 0-2.593 1.183-2.616 2.651v2.039h3.652v1.01H1.154a.664.664 0 0 1-.654-.656v-2.348c0-2.027 1.578-3.674 3.538-3.707H4.5l1.42-4.614A1.478 1.478 0 0 1 7.3 4.879h6.47c.501 0 .968.263 1.238.697l.013.022 2.975 4.954h3.16c1.282 0 2.323 1.06 2.344 2.375v3.607a.72.72 0 0 1-.692.73H9.956v-1.011H22.52v-3.286c0-.768-.598-1.392-1.34-1.404H4.097ZM13.77 5.89H7.323a.492.492 0 0 0-.463.338l-.005.015-1.325 4.309h11.312L14.187 6.13a.488.488 0 0 0-.4-.24h-.017Z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.852 5.385v5.307H8.84V5.385zm1.011 6.824v1.01H8.335v-1.01z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(3.027 12.462)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: "2.907",
  cy: "3.033",
  fill: "#FAFAFA",
  r: "2.527"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.907 0C1.3 0 0 1.358 0 3.033c0 1.675 1.301 3.033 2.907 3.033 1.605 0 2.906-1.358 2.906-3.033C5.813 1.358 4.512 0 2.907 0Zm0 1.068c1.04 0 1.883.88 1.883 1.965s-.843 1.965-1.883 1.965-1.884-.88-1.884-1.965.843-1.965 1.884-1.965Z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.36 1.666c.533-.26 1.085-.176 1.594.216l.09.072-.618.82c-.256-.218-.449-.255-.651-.156-.173.084-.261.242-.269.555v.09l-.989.023c-.016-.763.267-1.338.844-1.62Z",
  fill: "#000"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(15.16 12.462)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: "2.907",
  cy: "3.033",
  fill: "#FAFAFA",
  r: "2.527"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.25 3.411c-.191.548-.628.886-1.241.994l-.11.017-.128-.972c.323-.042.48-.155.552-.363.062-.178.017-.343-.189-.552l-.06-.058.664-.72c.525.485.718 1.06.511 1.654Z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.907 0C1.3 0 0 1.358 0 3.033c0 1.675 1.301 3.033 2.907 3.033 1.605 0 2.906-1.358 2.906-3.033C5.813 1.358 4.512 0 2.907 0Zm0 1.068c1.04 0 1.883.88 1.883 1.965s-.843 1.965-1.883 1.965-1.884-.88-1.884-1.965.843-1.965 1.884-1.965Z",
  fill: "#000"
}))));

export { curbsideIcon as default };
//# sourceMappingURL=curbsideIcon.js.map
